<template>
  <el-dialog
      :visible.sync="dialogVisible"
      title="选择下载发票格式"
      width="30%"
      top="5vh"
      @close="billNo = ''">
    <el-select v-model="type" placeholder="请选择发票格式">
      <el-option :value="1" label="pdf"/>
      <el-option :value="2" label="xml"/>
      <el-option :value="3" label="ofd"/>
    </el-select>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="downloadLoading" :disabled="billNo === ''" type="primary" @click="handleDownload">下载</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name: "InvoiceDownloadTypeSelect",
    components: {},
    data() {
      return {
        dialogVisible: false,
        downloadLoading: false,
        type: 1,
        billNo: "",
      };
    },
    methods: {
      open(billNo) {
        this.billNo = billNo;
        this.dialogVisible = true;
      },
      handleDownload() {
        this.downloadLoading = true;
        let param = {
          billNo: this.billNo,
        };
        this.$http.postForFile("basic", `invoiceApplication/downloadUrl/${this.type}`, null, param)
          .then((res) => {
            let blob = new Blob([res.data]);
            let disposition = res.headers["content-disposition"];
            let matchArray = disposition.match(/fileName=(.*)/);
            let filename = matchArray[1];
            let a = document.createElement("a");
            a.download = filename;
            a.href = URL.createObjectURL(blob);
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
            this.dialogVisible = false;
          }).finally(() => {
            this.downloadLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
